import { render, staticRenderFns } from "./TablePolls.vue?vue&type=template&id=501cd784&scoped=true&"
import script from "./TablePolls.vue?vue&type=script&lang=js&"
export * from "./TablePolls.vue?vue&type=script&lang=js&"
import style0 from "./TablePolls.vue?vue&type=style&index=0&id=501cd784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501cd784",
  null
  
)

export default component.exports